<div class="youtube-block">
  <div class="common-section-wrapper">
    <div class="common-container">
      <h3 class="common-section-title">{{ lg.youtubeBlock.heading }}</h3>
      <div class="youtube-list">
        @for (youtubeVideo of youtubeList; track youtubeVideo) {
          <div>
            <div class="youtube-item">
              <a href="{{ youtubeVideo.url }}" target="_blank">
                <img
                  src="{{ BaseAssetsURL + '/assets/images/youtube-block/' + youtubeVideo.src }}"
                  alt="track cover"
                  class="youtube-item__cover"
                />
                <img
                  src="{{ BaseAssetsURL + '/assets/images/youtube-block/youtube-logo.svg' }}"
                  alt="youtube icon"
                  class="youtube-item__icon"
                />
              </a>
            </div>
          </div>
        }
      </div>

      <div class="common-btn-container">
        <bmcore-button
          title="{{ lg.button.toChannel }}"
          icon="btv-icon-btn-youtube"
          component="LinkHref"
          linkPath="{{ youtubeChannel }}"
        >
        </bmcore-button>
      </div>
    </div>
  </div>
</div>
